export default "__VITE_ASSET__Bfvh$I8S__"